<template>
  <div id="ua-container">
    <div class="header">
      <a-button type="primary" class="orange-btn" @click="toReturn" v-if="!source && source !== 'app'">
        <a-icon type="rollback" />
        返回列表
      </a-button>
      <div class="flex alignItemsCenter">
        <img class="cover" :src="value.url" alt="无法加载">

        <div class="flex-1">
          <div class="title mb-3" v-if="value.name">
            {{ value.name }}
          </div>

          <div class="text mb-3">
            版本：{{ value.standardName ? value.standardName : "-" }}
          </div>

          <div class="text mb-3">
            年级：{{ value.gradeName ? value.gradeName : "-" }}
          </div>

          <div class="text mb-3">
            科目：{{ value.subjectName ? value.subjectName : "-" }}
          </div>

          <div class="text">
            创建时间：{{ value.createTime ? value.createTime : "-" }}
          </div>
        </div>
      </div>
    </div>
    <a-card class="ui-card card-box2">
      <a-spin :spinning="loading">
        <div class="flex justifyContentEnd">
          <!--
          <a-button class="download-btn mb-10" type="primary" @click="handleDownAnswer" v-if="value.answerUrl && value.subject !== 'ENGLISH' && source !== 'app'">
            下载答案
          </a-button>
          -->
          <a
            v-if="value.answerUrl && value.subject !== 'ENGLISH' && source !== 'app'"
            class="download-btn mb-10 ant-btn ant-btn-primary"
            :href="value | genDownloadUrl('答案')"
          >下载答案</a>
        </div>

        <div class="pagination-box mb-10">
          <div class="pagination" v-if="value.subject !== 'ENGLISH'">
            <!-- <a-pagination
              :total="pageCount"
              :pageSize="1"
              v-model="pageNum"
              :showTotal="(e) => `共：${pageCount ? pageCount : '0'}页`"
              size="small"
              :simple="false"
            /> -->
            <div class="text">
              共：{{ pageCount }} 页
            </div>
            <van-pagination v-model="pageNum" :page-count="pageCount" :show-page-size="5">
              <template #prev-text>
                <van-icon name="arrow-left" />
              </template>
              <template #next-text>
                <van-icon name="arrow" />
              </template>
              <template #page="{ text }">{{ text }}</template>
            </van-pagination>
          </div>
          <div v-else><a-icon type="customer-service" /> 听力</div>
          <div>
            <!--
            <a-button class="btn" type="primary" @click="handleDownAnswer" v-if="value.subject === 'ENGLISH' && value.answerUrl && source !== 'app'" style="margin-right: 10px;">
              下载答案
            </a-button>
            -->
            <a
              v-if="value.subject === 'ENGLISH' && value.answerUrl && source !== 'app'"
              class="btn ant-btn ant-btn-primary"
              style="margin-right: 10px;"
              :href="value | genDownloadUrl('答案')"
            >下载答案</a>
            <a-button class="btn" type="primary" @click="openListen" v-if="value.subject === 'ENGLISH'">
              <div>
                查看答案
              </div>
            </a-button>
          </div>
        </div>
        <template v-if="value.subject !== 'ENGLISH'">
          <div v-if="value.answerUrl">
            <div v-if="!isError">
              <div class="mask" v-if="parseInt(loadedRatio * 100) !== 100">
                <span>{{ loadingText }}</span>
                <a-progress
                  style="width: 280px"
                  strokeColor="#28b8ba"
                  :strokeWidth="10"
                  :percent="parseInt(loadedRatio * 100)"
                />
              </div>
            </div>
            <div class="loadError" v-else>答案加载失败，请稍后重试...</div>
            <ui-pdf
              class="pdfMain"
              :class="{ pdfContent: parseInt(loadedRatio * 100) === 100 }"
              :src="value.answerUrl"
              :page="pageNum"
              @progress="loadedRatio = $event"
              @num-pages="pageCount = $event"
              @error="pdfError($event)"
            />
          </div>
          <div v-else class="no-data">
            <a-empty description="暂无数据" />
          </div>
        </template>
        <template v-else>
          <div class="player-box" v-if="audioList && audioList.length > 0">
            <audio-player
              ref="audioPlayer"
              :playlist="audioList"
            />
          </div>
          <div class="no-data" v-else>
            <a-empty description="暂无听力材料" />
          </div>
        </template>
      </a-spin>
    </a-card>

    <template>
      <a-drawer
        title="查看答案"
        placement="right"
        :closable="true"
        width="100vw"
        :visible="listenVisible"
        @close="listenClose"
      >
        <div class="pagination">
          <!-- <a-pagination
            :total="pageCount"
            :pageSize="1"
            v-model="pageNum"
            size="small"
            :simple="false"
          /> -->
          <div class="text">
            共 {{ pageCount }} 页
          </div>
          <van-pagination v-model="pageNum" :page-count="pageCount" :show-page-size="5">
            <template #prev-text>
              <van-icon name="arrow-left" />
            </template>
            <template #next-text>
              <van-icon name="arrow" />
            </template>
            <template #page="{ text }">{{ text }}</template>
          </van-pagination>
        </div>
        <div v-if="value.answerUrl">
          <div v-if="!isError">
            <div class="mask" v-if="parseInt(loadedRatio * 100) !== 100">
              <span>{{ loadingText }}</span>
              <a-progress
                style="width: 280px"
                strokeColor="#28b8ba"
                :strokeWidth="10"
                :percent="parseInt(loadedRatio * 100)"
              />
            </div>
          </div>
          <div class="loadError" v-else>答案加载失败，请稍后重试...</div>
          <ui-pdf
            class="pdfMain"
            :class="{ pdfContent: parseInt(loadedRatio * 100) === 100 }"
            :src="value.answerUrl"
            :page="pageNum"
            @progress="loadedRatio = $event"
            @num-pages="pageCount = $event"
            @error="pdfError($event)"
          />
        </div>
        <div v-else class="no-data">
          <a-empty description="暂无数据" />
        </div>
      </a-drawer>
    </template>
  </div>
</template>

<script>

import axios from 'axios'
import uiPdf from "vue-pdf"
import audioPlayer from '@/components/player/index.vue'
import { getLessonAduioList } from '@/api/material.js'
import { genDownloadUrl } from "../utils.js"

export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    }
  },
  components: {
    uiPdf,
    audioPlayer
  },
  data() {
    return {
      // 加载进度
      loadedRatio: 0,
      pageNum: 1,
      loadingText: "努力加载中...",
      pageCount: 0,
      loading: false,
      isError: false,
      listenVisible: false,
      audioList: [],
      isShowVoice: false
    }
  },
  computed: {
    // 当从手机端跳转过来时会传递这两个参数 自动打开详情页且隐藏返回按钮
    source () {
      return this.$route.query?.source
    }
  },
  mounted() {
    if (this.value) {
      this.getLessonAduioList(this.value.id);
    }
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.toBack, false)
    }
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.toBack, false)
    if (this.$refs.audioPlayer) {
      this.$refs.audioPlayer.stop()
    }
  },
  filters: {
    genDownloadUrl,
  },
  methods: {
    // 返回
    toReturn() {
      this.$emit("change")
      this.isError = false
    },
    // 监听浏览器返回或手机物理按键返回
    toBack () {
      this.toReturn()
      console.log('返回了')
    },
    pdfError(err) {
      console.log(err)
      this.isError = true
    },
    handleDownAnswer () {
      this.downloadPdf(this.value.answerUrl, this.value.name)
    },
    // 检测是否在小程序环境中
    isMiniProgram() {
      // 检测微信小程序
      if (window.__wxjs_environment === 'miniprogram') {
        return 'wechat'
      }
      // 检测其他小程序环境的标识
      if (window.navigator.userAgent.toLowerCase().indexOf('miniprogram') > -1) {
        return 'miniprogram'
      }
      // 检测是否在webview中且缺少某些API
      if (!window.open || typeof window.open !== 'function') {
        return 'webview'
      }
      return false
    },
    async downloadPdf(pdfUrl, pdfName) {
      const miniProgramEnv = this.isMiniProgram()
      // 如果在小程序环境中
      if (miniProgramEnv) {
        uni.navigateTo({
          url: '/pages/user/web_view/downLoad?pdfUrl=' + encodeURIComponent(pdfUrl) + '&pdfName=' + encodeURIComponent(pdfName)
        })
        return
      }
      try {
        // 手机内嵌h5
        if (this.source === 'app') {
          if (window.DownloadPdf) {
            window.DownloadPdf.postMessage(pdfUrl)
          }
        } else {
          // 普通浏览器环境的下载逻辑
          const response = await axios.get(pdfUrl, {
            responseType: 'blob' // 关键：接收二进制数据
          })
          
          const blob = new Blob([response.data], { type: 'application/pdf' })
          const url = window.URL.createObjectURL(blob)

          const link = document.createElement('a')
          link.href = url
          link.download = pdfName + '.pdf'
          link.click()
          window.URL.revokeObjectURL(url)
        }
      } catch (error) {
        console.error('下载失败:', error)
        this.$message.error('下载失败，请稍后重试')
      }
    },
    openListen () {
      this.listenVisible = true
    },
    listenClose () {
      this.listenVisible = false
    },
    getLessonAduioList(materialId) {
      this.loading = true
      this.audioList = [];
      getLessonAduioList(materialId)
        .then((res) => {
          if (res.code === 0) {
            const audioList = res.data;
            this.audioList = this.formatMaterialData(audioList);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("服务器异常，听力材料加载失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatMaterialData(data) {
      let list = []
      if (data && data.length > 0) {
        data.forEach((item) => {
          list.push({
            id: item.id,
            title: item.name,
            src: item.audioUrl,
            cover: this.value.url
          })
        })
      }
      return list
    },
    // 播放
    handPlay () {
      this.isShowVoice = true
    },
    // 暂停
    handPause () {
      this.isShowVoice = false
    }
  }
}
</script>

<style lang="less" scoped>
#ua-container {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  overflow: auto;
  z-index: 999;
  background-color: #fff;
}
.orange-btn{
  margin-bottom: 20px;
}
// 修改新增等操作按钮默认颜色
.orange-btn{
  background-color: #FA7837;
  border-color: #FA7837;
  &:hover{
    background-color: #fa905b;
    border-color: #fa905b;
  }
}
.orange-btn:hover, .orange-btn:focus {
  background-color: #FA7837;
  border-color: #FA7837;
}
.card-box2 {
  border: none;
  position: relative;
  top: -30px;
  min-height: 57vh;
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-radius: 20px 20px 0 0;
}

.header{
  width: 100%;
  padding: 10px 10px 50px;
  background-color: #09C0D7;
  box-sizing: border-box;
  color: #fff;
}
.main{
  position: relative;
  top: -30px;
  padding: 20px 10px 10px;
  background-color: #fff;
  border-radius: 20px;
}
.cover{
  width: 80px;
  height: 110px;
  margin-right: 20px;
}
.title{
  font-size: 14px;
  font-weight: bold;
}
.text{
  font-size: 13px;
}

.mask {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 99;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.pdfMain {
  max-width: 600px;
  margin: 0 auto;
}
.pdfContent {
  box-shadow: 0 0 5px 1px #999;
}
.card-box2 .no-data {
  height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loadError {
  text-align: center;
  margin-top: 12%;
}
.pagination{
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  .text{
    font-size: 12px;
    margin-right: 6px;
  }
}
.pagination-box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .btn{
    height: 28px;
    text-align: center;
    line-height: 28px;
    background-color: #fff;
    border-color: #09C0D7;
    color: #09C0D7;
  }
}
.download-btn{
  height: 28px;
  text-align: center;
  line-height: 28px;
  background-color: #fff;
  border-color: #09C0D7;
  color: #09C0D7;
}
.no-data{
  height: 70vh;
}
/deep/.ant-drawer-body{
  padding: 15px !important;
}
/deep/.van-pagination__item{
  color: #09C0D7;
}
/deep/.van-pagination__item--active{
  color: #fff;
  background-color: #09C0D7;
}
</style>
